'use client'

import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import { useTranslations } from 'next-intl'
import Title from '@/app/components/common/Title'
import Text from '@/app/components/common/Text'
import { BlogPost } from '@/app/types/blog'
import { getSanityImageUrl } from '@/app/api/sanity'

interface Props {
	post: BlogPost
	lang: string
}

const BlogCard: FC<Props> = ({ post, lang }) => {
	const t = useTranslations('Blog')
	const imageUrl = getSanityImageUrl(post.mainImage, { width: 800, quality: 80 })
	const slug = post.slug?.current || ''

	return (
		<Link href={`/${lang}/blog/${slug}`} className="blog-card group">
			<div className="blog-card__image-wrapper">
				{imageUrl ? (
					<Image
						src={imageUrl}
						alt={post.mainImage?.alt || post.title}
						fill
						className="blog-card__image"
					/>
				) : (
					<div className="blog-card__image-placeholder" />
				)}
			</div>
			<div className="blog-card__content">
				<div className="blog-card__text">
					<Title level={3} bold color="text-900" className="blog-card__title" testId="blog-card-title">
						{post.title}
					</Title>
					<Text tag="p" color="text-800" className="blog-card__excerpt">
						{post.excerpt}
					</Text>
				</div>
				<span className="blog-card__meta">
					{t('readingTime', { minutes: post.readingTime })}
				</span>
			</div>
		</Link>
	)
}

export default BlogCard
